// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/ClashDisplay-Variable.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Clash Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Clash Display', sans-serif; 
  background-color: gray;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAAwE;AAC1E;;AAEA;EACE,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;AACjF","sourcesContent":["@font-face {\n  font-family: 'Clash Display';\n  src: url('../public/fonts/ClashDisplay-Variable.ttf') format('truetype');\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Clash Display', sans-serif; \n  background-color: gray;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
